import React from 'react';
import { Step, Icon } from 'semantic-ui-react';
import { withRouter } from 'react-router';

class InpatientNavigationView extends React.Component {

    render() {

        return (
            <Step.Group vertical fluid>
                <Step link
                    active={this.props.history.location.pathname === "/systemadmin/userinpatient/view"}
                    onClick={() => {
                        this.props.history.push({ pathname: "/systemadmin/userinpatient/view", search: this.props.history.location.search })
                    }}
                >
                    <Step.Content>
                        <Step.Title>Hospitalisation </Step.Title>
                        <Step.Description>Hospitalisation</Step.Description>
                    </Step.Content>
                </Step>
                <Step link
                    active={this.props.history.location.pathname === "/systemadmin/userinpatient/view/imbursement"}
                    onClick={() => {
                        this.props.history.push({ pathname: "/systemadmin/userinpatient/view/imbursement", search: this.props.history.location.search })
                    }}
                >
                    <Step.Content>
                        <Step.Title>Imbursement</Step.Title>
                        <Step.Description>Imbursement</Step.Description>
                    </Step.Content>
                </Step>
                <Step link
                    active={this.props.history.location.pathname === "/systemadmin/userinpatient/view/systemdata"}
                    onClick={() => {
                        this.props.history.push({ pathname: "/systemadmin/userinpatient/view/systemdata", search: this.props.history.location.search })
                    }}
                >
                    <Step.Content>
                        <Step.Title>System Data</Step.Title>
                        <Step.Description>System Data</Step.Description>
                    </Step.Content>
                </Step>


            </Step.Group>
        );

    }
}

export default withRouter(InpatientNavigationView);